import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import trainingListAction from './trainingList.action.json' with { type: 'json' }
import { trainingObject } from '../trainingObject'

export const trainingExpression = expression(trainingObject.shape)

const trainingListDefinition = defineAction({
  ...trainingListAction,

  input: z.object({
    filter: trainingExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: z.string().nullish(),
    order: z.string().nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({ items: z.array(trainingObject), count: z.number() }),
})

export default trainingListDefinition
